var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isSupported
    ? _c("div", { attrs: { "data-grm-comp": "Battery" } }, [
        _vm.charging
          ? _c("div", [
              _vm._v("[" + _vm._s(_vm.$t("camstudy.battery.charging")) + "]"),
              _c("span", [_vm._v(_vm._s(_vm.currentLevel) + "%")]),
            ])
          : _c("div", [
              _c("span", [_vm._v(_vm._s(_vm.currentLevel) + "%,")]),
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(_vm.calc.total.elapsedMinutes) +
                    _vm._s(_vm.$t("camstudy.battery.minutesUsing")) +
                    ","
                ),
              ]),
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(_vm.currentLevel - _vm.calc.total.level) +
                    "% " +
                    _vm._s(_vm.$t("camstudy.battery.used")) +
                    ","
                ),
              ]),
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.calc.total.remainMinutes > 0
                        ? _vm.calc.total.remainMinutes
                        : "-"
                    ) +
                    _vm._s(_vm.$t("camstudy.battery.minutesRemaining"))
                ),
              ]),
            ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }